import React, { useContext } from 'react';
import clsx from 'clsx';
import { AppContext } from './contexts/AppContext';
import Header from './components/Header';
import Filters from './components/Filters';
import Results from './components/Results';
import SortOverlay from './components/SortOverlay';
import DistanceOverlay from './components/DistanceOverlay';
import BookingBoxOverlay from './components/BookingBoxOverlay';
import Skeleton from 'react-loading-skeleton';
import PoiOverlay from './components/PoiOverlay';
import {translate} from './helpers/base';

const AccommodationOverview = () => {

    const {
        isLoading,
        isSortOverlayVisible,
        isDistanceOverlayVisible,
        isBookingBoxOverlayVisible,
        isMobile,
        currentMapPoi
    } = useContext(AppContext);

    return (
        <>
            <Header />
            <div className="accommodation-overview--content">
                <FilterContainer />
                <Results/>
            </div>
            <div className={clsx('accommodation-overview-sort--overlay', isSortOverlayVisible && 'is-visible')}>
                <SortOverlay/>
            </div>
            <div className={clsx('accommodation-overview-sort--overlay', isDistanceOverlayVisible && 'is-visible')}>
                <DistanceOverlay/>
            </div>
            <div className={clsx('page--overlay booking-box--overlay', isBookingBoxOverlayVisible && 'is-visible')}>
                <BookingBoxOverlay />
            </div>
            {isMobile && <div className={clsx('page--overlay map-poi--overlay', currentMapPoi && 'is-visible')}>
                {currentMapPoi && <PoiOverlay poi={currentMapPoi} />}
            </div>}
            {isLoading && <div className="accommodation-overview-loading--overlay" />}
        </>
    );
};

export default AccommodationOverview;

const FilterContainer = () => {

    const {
        isInitializing,
        isLoading,
        isFilterOverlayVisible,
        setIsFilterOverlayVisible,
        filteredResults
    } = useContext(AppContext);

    const handleApplyButtonClick = () => {
        setIsFilterOverlayVisible(false);
        window.requestAnimationFrame(() => window.scrollTo({top: 0, behavior: 'smooth'}));
    };

    return (
        <div className={clsx('accommodation-overview--filter form-container', isFilterOverlayVisible && 'is-visible', isLoading && 'is-loading')}>
            <div className="area--accordion">
                {isInitializing ? <Skeleton height={80} count={3} style={{marginBottom: 5}}/> : <Filters />}
            </div>
            <div className="accommodation-overview--filter-bottom">
                {/*
                <button type="button" className="btn btn-outline btn-clear btn-sm" onClick={handleClearButtonClick}>
                    {translate('accommodation-overview.filter.reset')}
                </button>
                <button type="button" className="btn btn-primary btn-switch btn-sm" onClick={handleApplyButtonClick}>
                    {translate('accommodation-overview.filter.apply')}
                </button>*/}
                <button type="button" className="btn btn-primary btn-sm" onClick={handleApplyButtonClick} disabled={isLoading || filteredResults.length === 0}>
                    {filteredResults.length ?
                        translate('accommodation-overview.filter.showResults', {count: filteredResults.length}) :
                        translate('accommodation-overview.filter.noResults')
                    }
                </button>
            </div>
        </div>
    )
}